import {useEffect, useState} from 'react';
import {FaChevronLeft, FaChevronRight} from 'react-icons/fa';
import NewsModal from './News/NewsModal';
import { useLanguage } from '../contexts/LanguageContext';
import {ImageTranslation} from "../translations/image.ts";
import NewsSecondModal from "./News/NewsSecondModal.tsx";

const News = () => {
  const [visibleSlides, setVisibleSlides] = useState([0, 1,2]);
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const { translations } = useLanguage();
  const [showNewsletterSecondModal, setShowNewsletterSecondModal] = useState(false);


  const { language } = useLanguage(); 
  const picture = ImageTranslation[language]; 


  const slides = [
    {
      image: '../../../assets/KI-Podcast_Niedersachsen-next.jpg',
      title: translations.PodcastbeiNIEDERSACHSEN,
      grid: 2,
      link: 'https://digitalagentur-niedersachsen.de/podcast-novobit-ki-zukunft/'       ,

      hoverPicture: false,
    },
    {
      image: '../../../assets/Pictures/Website_Newsletter_06-2025.jpg',
      title: '',
      grid: 1,
      isNewsletter: true,
      pdfUrl: translations.pdfUrlNewsLetter06,
      link: translations.pdfUrlNewsLetter06,
      // srcPicture: picture.newsLetterSecond,
      secondNewsLetter: true,
      titleModal: ''  ,
      hoverPicture: false,
    },
    {
      image: '../../../assets/Pictures/GEC_Ramzi_Guetari_Software_Development.jpg',
      title: translations.GERMANEMIRATES,
      grid: 2,
      isNewsletter: true,
      srcPicture: picture.newsLetterRamzi,
      hoverPicture: false,
    } 
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 700) {
        setVisibleSlides([0]); // Set to [0, 1] for screens 700px or smaller
      } else if (window.innerWidth <= 1088 ){
        setVisibleSlides([0, 1]);
      }  else {
        setVisibleSlides([0, 1, 2]); // Set to [0, 1, 2] for larger screens
      }
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Initial check for screen width on mount
    handleResize();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const [indexPicture, setIndexPicture] = useState<number | undefined>()
  const onClosePopUp = () => {
     setShowNewsletterModal(false)
    setShowNewsletterSecondModal(false)
    setIndexPicture(undefined)
  }
  
  const nextSlide = () => {
    setVisibleSlides(prev => {
      const newSlides = [...prev];
      const lastIndex = newSlides[prev.length -1];
      newSlides.shift();
      newSlides.push((lastIndex + 1) % slides.length);
      return newSlides;
    });
 
  };


  const prevSlide = () => {
    setVisibleSlides(prev => {
      const newSlides = [...prev];
      const firstIndex = newSlides[0];
      newSlides.pop();
      newSlides.unshift((firstIndex - 1 + slides.length) % slides.length);
      return newSlides;
    });
  };
  
  
  const handleSlideClick = (slideIndex: number) => {
    if (!slides[slideIndex].hoverPicture) {

      setIndexPicture(slideIndex)
      const slide = slides[slideIndex];
      if (slide.link && slide.link.length > 0) {
        window.open(slide.link, '_blank', '');
      } else if (slide.isNewsletter && slide.secondNewsLetter) {
        console.log('slideslide', slide)

        setShowNewsletterSecondModal(true);
    } else if (slide.isNewsletter &&  !slide.secondNewsLetter) {

        setShowNewsletterModal(true);
      }
    }
  };

 
  
  return (
    <div className="bg-[#a2a7aa] py-5">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-light text-white mb-5">{translations.news.toLowerCase()}</h2>
  
        <div className="relative">
          <div className="h-full  gap-5 flex" style={{
            height:' 368px',
            justifyContent: 'space-around'}}>
            {visibleSlides.map((slideIndex) => (
              <div 
                key={slideIndex} 
                className={`relative  cursor-pointer`}
                style={{height: '100%'}}
                onClick={() => handleSlideClick(slideIndex)}
              >
                <div className="relative rounded-lg overflow-hidden shadow-lg group h-[100%]">
                  {slides[slideIndex]?.hoverPicture ? (
                      <>

                        <img
                            src={slides[slideIndex]?.image}
                            alt="Brunis"
                            className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
                        />
                        <div className="absolute scrollDesign overflow-y-auto w-full h-full p-[13px]  cursor-auto top-0 bg-[#373f4a] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <h6 className="text-responsive text-white font-medium break-words  ">
                            {translations.DOAG_Tourbus}
                          </h6>

                          <p className="text-white text-responsive font-medium break-words pt-2  ">
                            {translations.DOAG_TourbusDesc1}
                          </p>

                          <p className="text-[#a3b0b9] text-responsive font-medium break-words pt-2  ">

                            {translations.DOAG_TourbusDesc2}
                          </p>
                        </div>
                      </>
                  ) : (
                      <img
                          src={slides[slideIndex]?.image}
                          className="w-full h-full  object-cover transition-transform duration-300 "
                      />  
                  )}
                  
                  {!slides[slideIndex]?.hoverPicture  &&

                      <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-[10px] left-[13px] text-white">
                          <h3 className="text-xl font-light">{slides[slideIndex]?.title}</h3>
                          <p className="text-sm">{translations.ClickLearnMore}</p>
                        </div>
                      </div>}
                
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={nextSlide}
            className="absolute right-[35px] top-1/2 -translate-y-1/2 translate-x-6 bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 focus:outline-none"
            aria-label="Next slide"
          >
            <FaChevronRight className="w-4 h-4" />
          </button>

          <button
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-6 bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 focus:outline-none"
              aria-label="Next slide"
          >
            <FaChevronLeft className="w-4 h-4" />
          </button>
        </div>
      </div>


      {showNewsletterModal && indexPicture &&  <NewsModal
          isOpen={showNewsletterModal}
          onClose={() => onClosePopUp()}
          pdfUrl={slides[indexPicture].pdfUrl}
          srcPicture={slides[indexPicture].srcPicture}
      />
      }


      {showNewsletterSecondModal && indexPicture &&  <NewsSecondModal
          isOpen={showNewsletterSecondModal}
          onClose={() => onClosePopUp()}
          srcPicture={slides[indexPicture].srcPicture}
      />
      }
    </div>
  );
};

export default News;
